import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=21f794b6&scoped=true"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"
import style0 from "./Rate.vue?vue&type=style&index=0&id=21f794b6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f794b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f794b6')) {
      api.createRecord('21f794b6', component.options)
    } else {
      api.reload('21f794b6', component.options)
    }
    module.hot.accept("./Rate.vue?vue&type=template&id=21f794b6&scoped=true", function () {
      api.rerender('21f794b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Rate.vue"
export default component.exports